import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, of, switchMap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LocationService } from '../services/location.service';
import { JwtService } from '../services/jwt.service';
import { createUrl } from '../services/api.util';

export const locationInterceptor: HttpInterceptorFn = (request, next) => {
  const locationService = inject(LocationService);
  const jwtService = inject(JwtService);
  const toastr = inject(ToastrService);
  const apiBase = createUrl().replace(/\/+$/, '');
  if (!request.url.startsWith(`${apiBase}/`) ||
      request.url === createUrl('auth', 'login') ||
      !request.headers.has('Authorization')) {
    return next(request);
  }

  locationService.startTracking();
  const latest = locationService.latestLocation();
  const location$ = latest ? of(latest) : locationService.getCurrentLocation();
  return location$.pipe(
    catchError((error: unknown) => {
      toastr.error(error instanceof Error ? error.message : 'Enable location access and try again.', 'Location required');
      return throwError(() => error);
    }),
    switchMap((location) => {
      // A session may have ended while the permission prompt was open.
      if (!jwtService.getJWTString()) {
        return throwError(() => new Error('Your session ended. Please sign in again.'));
      }
      return next(request.clone({ setHeaders: {
        'X-Latitude': String(location.latitude),
        'X-Longitude': String(location.longitude),
        'X-Location-Accuracy': String(location.accuracy),
        'X-Location-Timestamp': String(location.timestamp),
      } }));
    }),
  );
};
